var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.724 3.66416C27.3333 6.04016 27.3333 11.0002 27.3333 11.0002C27.3333 11.0002 27.3333 15.9602 26.724 18.3362C26.3853 19.6495 25.3947 20.6828 24.14 21.0322C21.8613 21.6668 14 21.6668 14 21.6668C14 21.6668 6.14266 21.6668 3.86 21.0322C2.6 20.6775 1.61066 19.6455 1.276 18.3362C0.666664 15.9602 0.666664 11.0002 0.666664 11.0002C0.666664 11.0002 0.666664 6.04016 1.276 3.66416C1.61466 2.35083 2.60533 1.3175 3.86 0.968162C6.14266 0.333496 14 0.333496 14 0.333496C14 0.333496 21.8613 0.333496 24.14 0.968162C25.4 1.32283 26.3893 2.35483 26.724 3.66416ZM11.3333 15.6668L19.3333 11.0002L11.3333 6.3335V15.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e511027fee02e5d7decb0342645952d3.svg";
export { ForwardRef as ReactComponent };